// extracted by mini-css-extract-plugin
module.exports = {"navbar":"App_navbar__BoB5D","wrapper":"App_wrapper__RCHjb"};